import * as yup from 'yup';
import { IUser } from './IUser';
export const BaseEntitySchema = yup.object({
  id: yup.string().required(),
});

export interface IBaseEntity {
  id: string;
  createdAt?: Date;
  updatedAt?: Date | null;
  deletedAt?: Date | null;
  createdBy?: IUser;
}
